import { EventNode } from "./bus";
// Spies
let _SpySubscriptions = null;
export const spySubscriptions = (fn) => {
    const prevSub = _SpySubscriptions;
    _SpySubscriptions = [];
    fn();
    const result = _SpySubscriptions;
    _SpySubscriptions = prevSub;
    return result;
};
export class PubSub extends EventNode {
    constructor(global) {
        super(global);
        this._subscriptions = [];
    }
    $touch(subscriber) {
        throw new Error("Method not implemented.");
    }
    $untouch() {
        throw new Error("Method not implemented.");
    }
    $publish(next, prev, keys) {
        throw new Error("Method not implemented.");
    }
    $subscribe(subscriber) {
        // if (this._destroyed) {
        //     console.error('Cannot subscribe to deleted value')
        //     return null
        // }
        // проверяем, что такая подписка уже есть
        for (let sub of this._subscriptions) {
            if (sub.subscriber == subscriber || sub.subscriber.$publish == subscriber) {
                return sub;
            }
        }
        if (typeof subscriber === 'function') {
            subscriber = {
                $publish: subscriber
            };
        }
        const sub = {
            subscriber,
            observable: this
        };
        this._subscriptions.push(sub);
        if (_SpySubscriptions) {
            _SpySubscriptions.push(sub);
        }
        return sub;
    }
    $unsubscribe(subscription) {
        // if (this._destroyed) {
        //     console.error('Cannot unsubscribe from deleted value')
        //     return 
        // }
        this._subscriptions = this._subscriptions.filter(sub => sub != subscription && sub.subscriber != subscription && sub.subscriber.$publish != subscription);
    }
    // $touch(subscriber: Subscriber<T>): void {
    //     //this._started = true
    //     subscriber.$publish(this.$value, undefined, EMPTY)
    // }
    // $untouch () {
    //     // TODO проверки при отсоединении
    // }
    get $subscriptions() {
        return this._subscriptions;
    }
}
